<template>
  <div class="m-pagination-primary">
    <p
      v-if="pagination.showLoadingState"
      class="m-pagination-primary-quantity"
      key="paginationLoadingState"
    >
      Cargando Datos...
    </p>
    <p
      v-else-if="pagination.totalQuantity === 0"
      class="font-weight-regular m-pagination-primary-quantity text-color-black-90"
      key="paginateNoResults"
    >
      No se encontraron resultados
    </p>
    <p
      v-else
      class="m-pagination-primary-quantity"
      key="paginateResults"
    >
      Mostrando
      {{ firstItemInCurrentPage }}
      a
      {{ lastItemInCurrentPage }}
      de
      {{ pagination.totalQuantity }}
      resultados
    </p>

    <ul
      v-show="pagination.totalPages > 1"
      class="m-pagination-primary-pages"
    >
      <li>
        <a
          :class="pagination.currentPage === 1 ? 'page-disabled' : 'page-inactive'"
          href="#"
          @click.prevent="setPaginationCurrentPage(1)"
        >
          Primero
        </a>
      </li>
      <li>
        <a
          :class="pagination.currentPage === 1 ? 'page-disabled' : 'page-inactive'"
          href="#"
          @click.prevent="setPaginationCurrentPage(pagination.currentPage - 1)"
        >
          Anterior
        </a>
      </li>
      <li
        v-for="(page, index) in visiblePages"
        :key="index"
      >
        <a
          :class="page === pagination.currentPage ? 'page-active' : 'page-inactive'"
          href="#"
          @click.prevent="setPaginationCurrentPage(page)"
        >
          {{ page }}
        </a>
      </li>
      <li>
        <a
          :class="pagination.currentPage === pagination.totalPages ? 'page-disabled' : 'page-inactive'"
          href="#"
          @click.prevent="setPaginationCurrentPage(pagination.currentPage + 1)"
        >
          Siguiente
        </a>
      </li>
      <li>
        <a
          :class="pagination.currentPage === pagination.totalPages ? 'page-disabled' : 'page-inactive'"
          href="#"
          @click.prevent="setPaginationCurrentPage(pagination.totalPages)"
        >
          Último
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'MoleculePaginationPrimary',

  props: {
    pagination: {
      type: Object,
      default: () => ({
        currentPage: 1,
        currentQuantity: 0,
        limit: 10,
        showLoadingState: false,
        totalPages: 0,
        totalQuantity: 0
      })
    }
  },

  data () {
    return {
      firstItemInCurrentPage: 0,
      lastItemInCurrentPage: 0,
      pagesCutOff: 5,
      visiblePages: []
    }
  },

  watch: {
    'pagination.currentPage': {
      handler () {
        this.firstItemInCurrentPage = (this.pagination.currentPage * this.pagination.limit) - this.pagination.limit + 1
        this.lastItemInCurrentPage = this.firstItemInCurrentPage + this.pagination.currentQuantity - 1
      },

      immediate: true
    },

    'pagination.currentQuantity': {
      handler () {
        this.lastItemInCurrentPage = this.firstItemInCurrentPage + this.pagination.currentQuantity - 1
      },

      immediate: true
    },

    'pagination.showLoadingState': {
      handler () {
        if (this.pagination.showLoadingState) {
          this.$alerts.pushAlert('mPaginationPrimary', 'showLoadingState', 'loading', 'a-alert-loading')
        } else {
          this.$alerts.closeAlert()
          this.setVisiblePages()
        }
      },

      immediate: true
    }
  },

  methods: {
    setPaginationCurrentPage (page) {
      if (this.pagination.currentPage !== page &&
        page <= this.pagination.totalPages &&
        page >= 1) {
        this.$emit('setPaginationCurrentPage', page)
      }
    },

    setVisiblePages () {
      if (this.pagesCutOff > this.pagination.totalPages) {
        this.visiblePages = Array.from(new Array(this.pagination.totalPages),
          (val, index) => index + 1)
      } else if (this.pagination.currentPage <= this.pagesCutOff) {
        this.visiblePages = Array.from(new Array(this.pagesCutOff),
          (val, index) => index + 1)
      } else if (this.pagination.currentPage >= this.pagination.totalPages - this.pagesCutOff + 1) {
        this.visiblePages = Array.from(new Array(this.pagesCutOff),
          (val, index) => this.pagination.totalPages - this.pagesCutOff + 1 + index)
      } else {
        this.visiblePages = Array.from(new Array(this.pagesCutOff),
          (val, index) => this.pagination.currentPage - parseInt(this.pagesCutOff / 2) + index)
      }
    }
  }
}
</script>
